module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qskel3-2f0eed5fe9fc9f1cd0c15d71897190a8.jpg";